module.exports = __webpack_public_path__ + "static/media/mexican_restaurant_menu_illustration_concepts_2017.e842d277.webp";